const headers = {
  name: "Product brand",
  navigate: {
    path: [
      {
        name: "Brands",
        path: "/app/products/brands",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
